export const timelineTranslations = {
  it: {
    AlertSeverity: {
      info: "Severità: informativa",
      low: "Severità: bassa",
      medium: "Severità: media",
      high: "Severità: alta"
    },
    ClinicalTimeline: {
      titolo: "Timeline Clinica",
      conteggio_eventi: "eventi",
      caricamento: "Caricamento timeline...",
      nessun_evento: "Nessun evento disponibile",
      ricerca_vuota: "Nessun evento trovato per la ricerca",
      cerca_placeholder: "Cerca evento...",
      zoom_label: "Periodo temporale",
      filtri_categoria: "Filtri per categoria",
      filtro_attivo: "Filtro attivo",
      rimuovi_filtro: "Rimuovi filtro",
      cat_patologie: "Patologie",
      cat_terapie: "Terapie",
      cat_fuori_norma: "Fuori Norma",
      cat_note: "Note",
      cat_referti: "Referti",
      filtro_patologie: "Filtra patologie",
      filtro_terapie: "Filtra terapie",
      filtro_fuori_norma: "Filtra fuori norma",
      filtro_note: "Filtra visite e note",
      filtro_referti: "Filtra referti",
      zoom_mese: "1 Mese",
      zoom_trimestre: "3 Mesi",
      zoom_semestre: "6 Mesi",
      zoom_anno: "1 Anno",
      zoom_oltre_anno: "Oltre un anno",
      zoom_tutto: "Tutto",
      sev_active: "Attiva",
      sev_resolved: "Risolta",
      sev_suspended: "Sospesa",
      sev_ended: "Terminata",
      sev_warning: "Attenzione",
      sev_danger: "Critico",
      valore: "Valore",
      min: "Min",
      max: "Max"
    }
  },
  en: {
    AlertSeverity: {
      info: "Severity: informational",
      low: "Severity: low",
      medium: "Severity: medium",
      high: "Severity: high"
    },
    ClinicalTimeline: {
      titolo: "Clinical Timeline",
      conteggio_eventi: "events",
      caricamento: "Loading timeline...",
      nessun_evento: "No events available",
      ricerca_vuota: "No events found for the search",
      cerca_placeholder: "Search event...",
      zoom_label: "Time period",
      filtri_categoria: "Category filters",
      filtro_attivo: "Active filter",
      rimuovi_filtro: "Remove filter",
      cat_patologie: "Pathologies",
      cat_terapie: "Therapies",
      cat_fuori_norma: "Out of Range",
      cat_note: "Visits/Notes",
      cat_referti: "Reports",
      filtro_patologie: "Filter pathologies",
      filtro_terapie: "Filter therapies",
      filtro_fuori_norma: "Filter out of range",
      filtro_note: "Filter visits and notes",
      filtro_referti: "Filter reports",
      zoom_mese: "1 Month",
      zoom_trimestre: "3 Months",
      zoom_semestre: "6 Months",
      zoom_anno: "1 Year",
      zoom_oltre_anno: "Older than 1 year",
      zoom_tutto: "All",
      sev_active: "Active",
      sev_resolved: "Resolved",
      sev_suspended: "Suspended",
      sev_ended: "Ended",
      sev_warning: "Warning",
      sev_danger: "Critical",
      valore: "Value",
      min: "Min",
      max: "Max"
    }
  }
};
